var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 21H4.5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v6m0 2v-2m2 10a2 2 0 0 1-2-2v-8m2 10a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2v0h-2v2m2 10v-9.6a.4.4 0 0 0-.4-.4h-1.6m-11 1.5h7m-7 2.5h7m-7 2.5h5m-6-11h9v3h-9v-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.b2a22c7eb3777cb2ce69f3f0459cfc42.svg";
export { ForwardRef as ReactComponent };